import { useContext, useEffect } from 'react';

import { Layout } from '@components';
import { PageContext } from '@contexts';
import { ProductPageSection } from '@containers';
import { getBackupImg } from '@helpers/dataExists';
import styles from './ProductGroup.module.scss';

const ProductGroup = () => {
  const data = useContext(PageContext);
  const { DisplayOptions, DarkMode } = data;

  useEffect(async () => {
    await getBackupImg();
  });

  return (
    <Layout className={styles.DefaultPage} DarkMode={DarkMode}>
      {DisplayOptions?.map((sectionData, index) => (
        <ProductPageSection
          key={`page-section-${index}`}
          data={sectionData}
          productType={data.ProductType}
          DarkMode={DarkMode}
        />
      ))}
    </Layout>
  );
};

export default ProductGroup;
